<div class="print-layout">
  <h2>{{ widgetName }}</h2>
  <div class="header" *ngIf="entityInfoValue">
    <div class="entity-info">
      <div class="info-row">{{ entityInfoValue }}</div>
    </div>
  </div>

  <div class="page-container" *ngFor="let page of pages">
    <div class="page-header">
      <div class="page-number">Table Part {{ page.pageNumber }} of {{ page.totalPages }}</div>
    </div>
    <div class="table-container">
      <table>
        <thead>
          <tr>
            <th *ngFor="let col of page.columns"
                [class.left-align]="isLeftAlignedColumn(col.Type)"
                [class.right-align]="isRightAlignedColumn(col.Type)"
                [class.centre-align]="isCenteredColumn(col.Type)">
              {{ col.Header }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of dataRows">
            <td *ngFor="let col of page.columns"
                [class.left-align]="isLeftAlignedColumn(col.Type)"
                [class.right-align]="isRightAlignedColumn(col.Type)"
                [class.centre-align]="isCenteredColumn(col.Type)">
              {{ formatByColumnType(row[col.Name], col.Type) }}
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr *ngIf="footerValues">
            <td *ngFor="let column of page.columns"
                [class.left-align]="isLeftAlignedColumn(column.Type)"
                [class.right-align]="isRightAlignedColumn(column.Type)"
                [class.centre-align]="isCenteredColumn(column.Type)"
                class="bold">
              {{formatByColumnType(footerValues[column.field], column.Type)}}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>

  <div class="footer">
    <div>Generated on {{ now() | date:'medium' }}</div>
  </div>
</div>
